import { render, staticRenderFns } from "./waitPay.vue?vue&type=template&id=7b03543f"
import script from "./waitPay.vue?vue&type=script&lang=js"
export * from "./waitPay.vue?vue&type=script&lang=js"
import style0 from "./waitPay.vue?vue&type=style&index=0&id=7b03543f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports